import React from "react"
import { SecondaryLinkTilesType } from "../../types/mainModulTypes"
import { API } from "../../constants/constants"
import { HashLink } from "react-router-hash-link"
import BaseSubheadline from "../common/BaseSubheadline"

export default function SecondaryLinkTiles(props: SecondaryLinkTilesType) {
    return (
        <div className="max-w-content-sm mx-auto flex flex-col justify-center px-4 lg:px-0">
            <div className="flex justify-center items-start gap-8 flex-wrap-reverse pb-12">
                {props?.secondaryLinkTilesBlock?.map((item, index) => (
                    <div key={index} className="flex flex-col items-center gap-4 w-48 lg:w-3/12">
                        <HashLink
                            to={item?.secondaryLinkTilesBlockEntryUrl}
                            className={`relative rounded-xl overflow-hidden border-4`}
                            style={{ borderColor: item.secondaryLinkTilesBlockEntryColor }}>
                            <img
                                src={API + item?.secondaryLinkTilesBlockEntryImage?.url}
                                alt={item.secondaryLinkTilesBlockEntryImage?.description ?? item.secondaryLinkTilesBlockEntryImage?.name}
                                className="w-full aspect-square object-cover"
                            />
                            <img
                                src={API + item?.secondaryLinkTilesBlockEntryIcon?.url}
                                alt={item.secondaryLinkTilesBlockEntryIcon?.description ?? item.secondaryLinkTilesBlockEntryIcon?.name}
                                className={`absolute w-12 h-12 object-contain rounded-md bg-white border-2 top-0 left-0 p-1`}
                                style={{ borderColor: item.secondaryLinkTilesBlockEntryColor }}
                            />
                        </HashLink>
                        <BaseSubheadline label={item.secondaryLinkTilesBlockEntryTitle} customColor={item.secondaryLinkTilesBlockEntryColor} />
                    </div>
                ))}
            </div>

            {props?.secondaryLinkTilesImagesToggle && (
                <>
                    <div className="flex gap-4 justify-center pb-4 flex-wrap">
                        <img
                            src={API + props?.secondaryLinkTilesImages1.url}
                            alt={API + props?.secondaryLinkTilesImages1.description}
                            className="w-24 object-contain"
                        />
                        <img
                            alt={API + props?.secondaryLinkTilesImages2.description}
                            src={API + props?.secondaryLinkTilesImages2.url}
                            className="w-24 object-contain"
                        />
                        <img
                            src={API + props?.secondaryLinkTilesImages3.url}
                            alt={API + props?.secondaryLinkTilesImages3.description}
                            className="w-24 object-contain"
                        />
                    </div>
                    <small className="text-center">{props?.secondaryLinkTilesImagesText}</small>
                </>
            )}
        </div>
    )
}
